//refer INC019
import React from 'react';
import { Breadcrumb, Button, Form, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import ReactTable from 'react-table';
import Papa from 'papaparse';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-table/react-table.css';
import './Configreport.css';

const NO_DOCUMENTS = [];
const configData = require('./../../config.json');
const isValidList = (value) => Array.isArray(value) && value.length > 0;

// Identify columns that represent monetary values.
const isCurrencyColumn = (columnName) =>
  /\b(amount|profit|loss|lose|expense|expenses|revenue|cost|price|income|salary|payment|payments|balance|budget|sales|tax|total)\b/i
    .test(String(columnName || '').replace(/([a-z])([A-Z])/g, '$1 $2'));

// Add a dollar symbol only when one is not already present.

const formatCurrencyValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return value;
  }

  const text = String(value).trim();

  // If the dollar symbol is already present, preserve it.
  if (text.includes('$')) {
    return text;
  }

  // Handle numbers containing commas and negative values in parentheses.
  const numericText = text.replace(/,/g, '').replace(/^\((.*)\)$/, '-$1');

  // Do not modify non-numeric values.
  if (!/^-?\d+(\.\d+)?$/.test(numericText)) {
    return text;
  }

  const amount = Number(numericText);
  const formattedAmount = Math.abs(amount).toFixed(2);

  return amount < 0
    ? `-$${formattedAmount}`
    : `$${formattedAmount}`;
};

// Format a value only when its column appears to be monetary.
const formatReportValue = (columnName, value) =>
  isCurrencyColumn(columnName) ? formatCurrencyValue(value) : value;


  const getSortableReportDate = (row) => {
    const value =
      row.Date ||
      row.date ||
      row.processedDate ||
      row.createdt ||
      row.createdDate ||
      row.created_at;
  
    if (!value) return null;
  
    const parsed = moment(
      value,
      [
        moment.ISO_8601,
        'MM-DD-YYYY',
        'MM/DD/YYYY',
        'DD-MM-YYYY',
        'DD/MM/YYYY',
        'YYYY-MM-DD',
        'YYYY/MM/DD'
      ],
      true
    );
  
    return parsed.isValid() ? parsed.valueOf() : null;
  };
  

export default class PreConfiguredReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileTypes: [],
      fileSubtypes: [],
      fileType: '',
      fileSubtype: '',
      fileValidationOrgId: '',
      isLoadingFileTypes: false,
      preConfiguredReport: '',
      startDate: '',
      endDate: '',
      reportlist: [],
      originalreportlist: [],
      columns: [],
      isFetching: false,
      hasGenerated: false,
      isExportMenuOpen: false
    };
  }

  componentDidMount() {
    // Load organisation-scoped File Type and Subtype options.
    this.fetchFileValidationOrganization();
  }

  fetchFileValidationOrganization = () => {
    const session = localStorage.getItem('session');
    if (!session) {
      console.error('Unable to resolve organisation: session was not found.');
      toast.error('Unable to identify your organisation. Please sign in again.');
      return;
    }

    let userlogin;
    try {
      userlogin = JSON.parse(session);
    } catch (error) {
      console.error('Unable to parse login session:', error);
      toast.error('Unable to identify your organisation. Please sign in again.');
      return;
    }

    const fullOrgName = userlogin && userlogin.Result && userlogin.Result[0]
      ? userlogin.Result[0].org
      : '';

    if (!fullOrgName) {
      console.error('Organisation name was not found in the login session.');
      toast.error('Unable to identify your organisation.');
      return;
    }

    this.setState({ isLoadingFileTypes: true });
    fetch(`${configData.FILEVALIDATION_URL}get_organizations`)
      .then((response) => {
        if (!response.ok) throw new Error(`get_organizations returned ${response.status}`);
        return response.json();
      })
      .then((organizations) => {
        // Match the complete organisation path (for example, Digital Corp/DCNZ),
        // then use the corresponding File Validation organisation ID.
        const matchedOrganization = Array.isArray(organizations)
          ? organizations.find((item) => item && item[0] === fullOrgName)
          : null;

        if (!matchedOrganization || !matchedOrganization[1]) {
          throw new Error(`Organisation '${fullOrgName}' was not found in File Validation.`);
        }

        const orgId = matchedOrganization[1];
        this.setState({ fileValidationOrgId: orgId }, () => this.fetchFileTypes(orgId));
      })
      .catch((error) => {
        console.error('Unable to resolve File Validation organisation:', error);
        this.setState({ fileValidationOrgId: '', fileTypes: [], fileSubtypes: [], isLoadingFileTypes: false });
        toast.error('Unable to load organisation-specific file types.');
      });
  };

  fetchFileTypes = (orgId) => {
    if (!orgId) return;

    this.setState({ isLoadingFileTypes: true, fileTypes: [], fileSubtypes: [] });
    fetch(`${configData.FILEVALIDATION_URL}get_filetypes?Organization=${encodeURIComponent(orgId)}`)
      .then((response) => {
        if (!response.ok) throw new Error(`get_filetypes returned ${response.status}`);
        return response.json();
      })
      .then((result) => {
        if (Array.isArray(result) && result[0] !== NO_DOCUMENTS) {
          this.setState({ fileTypes: _.uniq(result.filter((type) => typeof type === 'string' && type.trim())), isLoadingFileTypes: false });
        } else {
          this.setState({ fileTypes: [], fileSubtypes: [], isLoadingFileTypes: false });
          toast.info('No file types were found for your organisation.');
        }
      })
      .catch((error) => {
        console.error('Unable to fetch organisation-specific file types:', error);
        this.setState({ fileTypes: [], fileSubtypes: [], isLoadingFileTypes: false });
        toast.error('Unable to load file types. Please try again.');
      });
  };

  fetchFileSubtypes = (fileType) => {
    const { fileValidationOrgId } = this.state;
    if (!fileType || !fileValidationOrgId) {
      this.setState({ fileSubtypes: [], fileSubtype: '' });
      return;
    }

    const url = `${configData.FILEVALIDATION_URL}filterdata?company=${encodeURIComponent(fileValidationOrgId)}&fileType=${encodeURIComponent(fileType)}&fileStructureName=&fileFrequency=&mailId=`;
    this.setState({ fileSubtypes: [], fileSubtype: '', isLoadingFileTypes: true });

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`filterdata returned ${response.status}`);
        return response.json();
      })
      .then((result) => {
        if (!Array.isArray(result) || result[0] === NO_DOCUMENTS) {
          this.setState({ fileSubtypes: [], isLoadingFileTypes: false });
          return;
        }

        const subtypes = _.uniq(result
          .map((item) => item && item.fileStructureName)
          .filter((name) => typeof name === 'string' && name.trim()));
        this.setState({ fileSubtypes: subtypes, isLoadingFileTypes: false });
      })
      .catch((error) => {
        console.error('Unable to fetch file subtypes:', error);
        this.setState({ fileSubtypes: [], fileSubtype: '', isLoadingFileTypes: false });
        toast.error('Unable to load file subtypes. Please try again.');
      });
  };

  getAvailableSubtypes = () => this.state.fileSubtypes;


  handleFileTypeChange = (event) => {
    const fileType = event.target.value;
    this.setState({ fileType, fileSubtype: '', preConfiguredReport: '', reportlist: [], originalreportlist: [], hasGenerated: false }, () => {
      this.fetchFileSubtypes(fileType);
    });
  };

  handleFileSubtypeChange = (event) => {
    this.setState({ fileSubtype: event.target.value, preConfiguredReport: '', reportlist: [], originalreportlist: [], hasGenerated: false });
  };


  handleDateChange = (event) => {
    this.setState({ [event.target.name]: event.target.value, reportlist: [], originalreportlist: [], hasGenerated: false });
  };

  getReportDate = (row) => {
    const value = row.processedDate || row.createdt || row.createdDate || row.created_at || row.date;
    if (!value) return null;
    const parsed = moment(value, [moment.ISO_8601, 'MM-DD-YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
    return parsed.isValid() ? parsed.startOf('day') : null;
  };


  handleGenerateReport = () => {
    const { fileType, fileSubtype, startDate, endDate } = this.state;

    if (!fileType) {
      toast.warn('Please select a File Type.');
      return;
    }
    if (!fileSubtype) {
      toast.warn('Please select a File Subtype.');
      return;
    }
    if (startDate && endDate && moment(startDate).isAfter(moment(endDate), 'day')) {
      toast.warn('Start Date must be on or before End Date.');
      return;
    }

    const requestBody = {
      file_type: fileType,
      file_subtype: fileSubtype
    };
    if (startDate) requestBody.start_date = startDate;
    if (endDate) requestBody.end_date = endDate;

    const reportsApiUrl = (configData.REPORTS_API_URL).replace(/\/?$/, '/');
    this.setState({ isFetching: true, hasGenerated: false, reportlist: [], originalreportlist: [], columns: [] });

    axios
      .post(`${reportsApiUrl}api/reports/generate`, requestBody, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(({ data }) => {


        const rows = (Array.isArray(data && data.rows) ? data.rows : [])
        .map((row, index) => ({ row, index, date: getSortableReportDate(row) }))
        .sort((a, b) => {
          // Rows with valid dates appear before rows without dates.
          if (a.date === null && b.date !== null) return 1;
          if (a.date !== null && b.date === null) return -1;
      
          // Newest date first; preserve original order for equal or missing dates.
          if (a.date === b.date) return a.index - b.index;
          if (a.date === null && b.date === null) return a.index - b.index;
      
          return b.date - a.date;
        })
        .map((item) => item.row);
      

        const columns = Array.isArray(data && data.columns) && data.columns.length
          ? data.columns.map((key) => ({
              Header: key,
              accessor: (row) => formatReportValue(key, row[key]),
              id: key,
              sortable: true,
              show: true,
              minWidth: 120,
              className: isCurrencyColumn(key) ? 'currency-column' : '' //INC026
            }))
          : (rows.length
            ? Object.keys(rows[0]).filter((key) => key !== '_id').map((key) => ({
                Header: key,
                accessor: (row) => formatReportValue(key, row[key]),
                id: key,
                sortable: true,
                show: true,
                minWidth: 120
              }))
            : []);
        
        this.setState({
          reportlist: rows,
          originalreportlist: rows,
          columns,
          isFetching: false,
          hasGenerated: true,
          preConfiguredReport: `${fileSubtype}_merged`
        });

        if (rows.length) {
          toast.success(`Report generated successfully (${rows.length} rows).`);
        } else {
          toast.info('The API returned no rows for the selected subtype and date range.');
        }
      })
      .catch((error) => {
        const responseDetail = error && error.response && error.response.data
          ? error.response.data.detail
          : '';
        console.error('Unable to generate merged report:', error);
        this.setState({
          isFetching: false,
          reportlist: [],
          originalreportlist: [],
          columns: [],
          hasGenerated: true
        });
        toast.error(responseDetail || 'Unable to generate the report. Check the FastAPI server and try again.');
      });
  };



  // Format the report date range for PDF and CSV
  getReportPeriod = () => {
    const { startDate, endDate } = this.state;

    const formatDate = (value) => {
      if (!value) return '';

      const parsedDate = moment(value);
      return parsedDate.isValid()
        ? parsedDate.format('DD MMMM YYYY')
        : String(value);
    };

    if (startDate && endDate) {
      return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    }

    if (startDate) {
      return `From ${formatDate(startDate)}`;
    }

    if (endDate) {
      return `Up to ${formatDate(endDate)}`;
    }

    return 'All available dates';
  };

  // PDF export with report heading, metadata, and page numbers
  handlePDFExport = () => {
    const {
      reportlist,
      fileType,
      fileSubtype
    } = this.state;

    if (!isValidList(reportlist)) {
      toast.warn('Generate a report before exporting.');
      return;
    }

    const keys = Object.keys(reportlist[0])
      .filter((key) => key !== '_id');

    const doc = new JsPDF({
      orientation: keys.length > 6 ? 'landscape' : 'portrait'
    });

    const reportName = fileSubtype || 'ConfiguredReport';
    const reportPeriod = this.getReportPeriod();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const leftMargin = 14;

    // Report heading and metadata
    const drawHeader = () => {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(16);
      doc.text(reportName, leftMargin, 18);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text(`File Type: ${fileType || 'N/A'}`, leftMargin, 27);
      doc.text(`Report Period: ${reportPeriod}`, leftMargin, 34);
    };

    doc.autoTable({
      head: [keys],
      body: reportlist.map((row) =>
      keys.map((key) => {
        const value = formatReportValue(key, row[key]);
        return value == null ? '' : String(value);
      })
    ),
      startY: 42,
      margin: {
        top: 42,
        bottom: 18,
        left: leftMargin,
        right: leftMargin
      },
      styles: {
        fontSize: 8,
        overflow: 'linebreak',
        cellPadding: 2
      },
      didDrawPage: () => {
        // Repeat the report header on every page
        drawHeader();
      }
    });

    // Add "Page X of Y" to every page
    const totalPages = doc.internal.getNumberOfPages();

    for (let page = 1; page <= totalPages; page += 1) {
      doc.setPage(page);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);

      doc.text(
        `Page ${page} of ${totalPages}`,
        pageWidth / 2,
        pageHeight - 8,
        { align: 'center' }
      );
    }

    doc.save(`${this.getSafeFilename(reportName)}.pdf`);

    this.setState({ isExportMenuOpen: false });
  };

  // CSV export with report metadata before the table
  handleCSVExport = () => {
    const {
      reportlist,
      fileType,
      fileSubtype
    } = this.state;

    if (!isValidList(reportlist)) {
      toast.warn('Generate a report before exporting.');
      return;
    }

    const reportName = fileSubtype || 'ConfiguredReport';
    const reportPeriod = this.getReportPeriod();

    const keys = Object.keys(reportlist[0])
      .filter((key) => key !== '_id');

    const dataRows = reportlist.map((row) =>
      keys.map((key) => {
        const value = formatReportValue(key, row[key]);
    
        return value == null ? '' :
          typeof value === 'object' ? JSON.stringify(value) : value;
      })
    );

    const csvData = [
      ['Report', reportName],
      ['File Type', fileType || 'N/A'],
      ['Report Period', reportPeriod],
      [],
      keys,
      ...dataRows
    ];

    const csv = Papa.unparse(csvData);
    const blob = new Blob(['\uFEFF', csv], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    anchor.href = url;
    anchor.download = `${this.getSafeFilename(reportName)}.csv`;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);

    this.setState({ isExportMenuOpen: false });
  };

  // Produce a safe filename using the selected subtype
  getSafeFilename = (name) =>
    (name || 'ConfiguredReport')
      .replace(/\.[^.]+$/, '')
      .replace(/[^a-z0-9_-]/gi, '_');

  
  render() {
    const { fileTypes, fileType, fileSubtype, preConfiguredReport, startDate, endDate, reportlist, columns, isFetching, hasGenerated, isExportMenuOpen, isLoadingFileTypes } = this.state;
    const subtypes = this.getAvailableSubtypes();

    return (
      <div className="preconfigured-report-page" role="main">
        <Breadcrumb className="vissat-breadcrumb">
          <Breadcrumb.Item><Link to="/Home">Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item active>Configuration Reports</Breadcrumb.Item>
        </Breadcrumb>

        <ToastContainer position="top-right" autoClose={3000} />

        <section className="vissat-page-header-banner">
          <div>
            <h1 className="vissat-header-title">Configuration Reports</h1>
            <p className="vissat-header-subtitle">Merge matching source collections by file subtype and view the combined report</p>
          </div>
          <div className="vissat-header-illustration-area" aria-hidden="true">
            <div className="vissat-report-illustration"><span className="illustration-line line-one" /><span className="illustration-line line-two" /><span className="illustration-line line-three" /><span className="illustration-plus">+</span></div>
            <div>
              <div className="vissat-banner-tag">Your Reports.<br />Your Insights.</div>
              <div className="vissat-banner-accent-bar" />
            </div>
          </div>
        </section>

        <section className="vissat-card-tile config-report-tile">
          <div className="filter-controls-group">
            <div className="filter-section">
              <div className="filter-input-content">
                <label className="filter-label" htmlFor="preconfig-file-type">File Type</label>
                <Form.Control id="preconfig-file-type" as="select" className="vissat-select-control" value={fileType} onChange={this.handleFileTypeChange} disabled={isLoadingFileTypes || !this.state.fileValidationOrgId}>
                  <option value="">Select File Type</option>
                  {fileTypes.map((type) => <option key={type} value={type}>{type}</option>)}
                </Form.Control>
              </div>
            </div>

            <div className="filter-section">
              <div className="filter-input-content">
                <label className="filter-label" htmlFor="preconfig-file-subtype">File Subtype</label>
                <Form.Control id="preconfig-file-subtype" as="select" className="vissat-select-control" value={fileSubtype} onChange={this.handleFileSubtypeChange} disabled={!fileType || !subtypes.length || isLoadingFileTypes}>
                  <option value="">Select File Subtype</option>
                  {subtypes.map((type) => <option key={type} value={type}>{type}</option>)}
                </Form.Control>
              </div>
            </div>


            <div className="filter-section date-filter-section">
              <div className="filter-input-content">
                <label className="filter-label" htmlFor="preconfig-start-date">Start Date</label>
                <Form.Control id="preconfig-start-date" type="date" name="startDate" value={startDate} onChange={this.handleDateChange} className="vissat-select-control vissat-date-control" />
              </div>
            </div>

            <div className="filter-section date-filter-section">
              <div className="filter-input-content">
                <label className="filter-label" htmlFor="preconfig-end-date">End Date</label>
                <Form.Control id="preconfig-end-date" type="date" name="endDate" value={endDate} onChange={this.handleDateChange} className="vissat-select-control vissat-date-control" />
              </div>
            </div>

            <Button className="btn-generate-report" onClick={this.handleGenerateReport} disabled={isFetching || !fileSubtype}>
              {isFetching ? <><Spinner animation="border" size="sm" /> <span>Loading...</span></> : <><span aria-hidden="true">↗</span> Generate Report</>}
            </Button>
          </div>
          {!this.state.fileValidationOrgId && <small className="preconfig-helper-text">Resolving your organisation to load its file types...</small>}
          {fileType && !subtypes.length && !isLoadingFileTypes && <small className="preconfig-helper-text">No subtypes were found for the selected file type.</small>}
        </section>

        <section className="vissat-card-tile report-results-tile">
          <div className="results-header-bar">
            <div className="results-header-title-group">
 {/*INC026*/}
              <div className="results-header-text">
                <h5>Report Results</h5>
                <p3>{hasGenerated ? `${reportlist.length} row(s) returned` : 'Generate a report to view its results here.'}</p3>
              </div>
            </div>
            <div className="export-dropdown-container">
              <Button variant="light" className="btn-export-dropdown" onClick={() => this.setState((prev) => ({ isExportMenuOpen: !prev.isExportMenuOpen }))} disabled={!reportlist.length}>
                Export<span aria-hidden="true"></span>
              </Button>
              {isExportMenuOpen && <div className="export-menu-dropdown">
                <button type="button" className="export-menu-item" onClick={this.handlePDFExport}>Export as PDF</button>
                <button type="button" className="export-menu-item" onClick={this.handleCSVExport}>Export as CSV</button>
              </div>}
            </div>
          </div>

          {isFetching ? (
            <div className="vissat-empty-state"><Spinner animation="border" /><p className="empty-state-subtext">Loading report data...</p></div>
          ) : reportlist.length ? (
            <div className="results-table-container">
              <ReactTable data={reportlist} columns={columns} defaultPageSize={15} pageSizeOptions={[10, 15, 25, 50]} className="-striped -highlight vissat-react-table" minRows={0} />
            </div>
          ) : (
            <div className="vissat-empty-state">
              <div className="results-header-icon" aria-hidden="true">...</div>
              <p className="empty-state-title">{hasGenerated ? 'No matching results' : 'No report selected'}</p>
              <p className="empty-state-subtext">{hasGenerated ? 'Try another report or adjust the date range.' : 'Choose a file type and subtype, then select Generate Report.'}</p>
            </div>
          )}
        </section>
      </div>
    );
  }
}